const CostCenterGroupConstants = {
  GET_COST_CENTER_GROUP_LIST_SUCCESS: "GET_COST_CENTER_GROUP_LIST_SUCCESS",
  GET_COST_CENTER_GROUP_LIST_FAILURE: "GET_COST_CENTER_GROUP_LIST_FAILURE",
  ADDORUPDATE_COST_CENTER_GROUP_SUCCESS:
    "ADDORUPDATE_COST_CENTER_GROUP_SUCCESS",
  ADDORUPDATE_COST_CENTER_GROUP_FAILURE:
    "ADDORUPDATE_COST_CENTER_GROUP_FAILURE",
  DELETE_COST_CENTER_GROUP_SUCCESS: "DELETE_COST_CENTER_GROUP_SUCCESS",
  DELETE_COST_CENTER_GROUP_FAILURE: "DELETE_COST_CENTER_GROUP_FAILURE",
};

export default CostCenterGroupConstants;
